import {
  AwaitingStocktakingCountsState,
  AwaitingStoreStocktakingItemsState,
  REQUEST_AWAITING_STORE_STOCKTAKING_ITEMS,
  REQUEST_AWAITING_STOCKTAKING_COUNTS,
  StocktakingActionTypes,
  REQUEST_AWAITING_STORE_CLUSTER_STOCKTAKING_ITEMS
} from "./types";
import { ok } from "../../result";

const initialAwaitingStocktakingCounts: AwaitingStocktakingCountsState = {
  awaitingStoreStocktakingCounts: ok({
    storeCounts: [],
    storeTotalCount: 0
  })
};

const initialAwaitingStoreStocktakingItems: AwaitingStoreStocktakingItemsState = {
  stocktakingItems: ok([])
};

export function awaitingStocktakingCountsReducer(
  state = initialAwaitingStocktakingCounts,
  action: StocktakingActionTypes
) {
  switch (action.type) {
    case REQUEST_AWAITING_STOCKTAKING_COUNTS:
      console.log("reducer", action);
      return action.payload;
    default:
      return state;
  }
}

export function awaitingStoreStocktakingItemsReducer(
  state = initialAwaitingStoreStocktakingItems,
  action: StocktakingActionTypes
) {
  switch (action.type) {
    case REQUEST_AWAITING_STORE_STOCKTAKING_ITEMS:
      return action.payload;
    default:
      return state;
  }
}
